import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { Grid, Divider as MuiDivider, Typography as MuiTypography } from "@mui/material";
import { spacing } from "@mui/system";
import { roundOff } from "../../../utils/common";

import CustomDataGrid from "./CustomDataGrid";
import useReports from "../../../hooks/useReports";
import { useDialog } from "../../../contexts/DialogContext";
import { getTimeStamp, formatDate } from "../../../utils/common";
import Stats from "./../../../components/Stats";
import {
  LocalOffer as DiscountIcon,
  ReceiptLong as ReceiptLongIcon,
  CurrencyRupee as CurrencyRupeeIcon,
  AccountBalanceWallet as WalletIcon,
} from "@mui/icons-material";
const Divider = styled(MuiDivider)(spacing);

const Typography = styled(MuiTypography)(spacing);

function DueReports() {
  const { getDueReports, isLoading, dueReports, paging, downloadDuesReport } = useReports();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { openDialog } = useDialog();

  const [filterResetFunc, setFilterResetFunc] = useState(
    () => () => console.log("Refresh initialized"),
  );

  const today = formatDate(new Date());

  const currentPayload = {
    filters: [
      {
        fieldName: "invoiceDate",
        fieldValue: `${today} 00:00:00,${today} 23:59:59`,
        op: "btn",
        dataType: "date",
        condition: "and",
        isJoin: false,
      },
    ],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [
      {
        field: "createdAt",
        sort: "desc",
      },
    ],
  };

  const [sortModel, setSortModel] = useState([
    {
      field: "updatedAt",
      sort: "desc",
    },
  ]);
  const [filterFormData, setFilterFormData] = useState({
    invoiceDate: [new Date(), new Date()],
    invoiceDateStr: `${today} 00:00:00,${today} 23:59:59`,
  });

  const [payload, setPayload] = useState(currentPayload);

  const fetchData = async () => {
    await getDueReports(payload);
  };

  const refreshPage = () => {
    setPayload(currentPayload);
    setFilterFormData({
      invoiceDate: [new Date(), new Date()],
      invoiceDateStr: `${today} 00:00:00,${today} 23:59:59`,
    });
    filterResetFunc();
    setPaginationModel({
      page: 0,
      pageSize: 100,
    });
  };

  const onPageChange = (newPaginationModel) => {
    console.log(newPaginationModel, "pagepage");

    const pagination = {
      pageNumber: newPaginationModel.page === 0 ? 1 : newPaginationModel.page + 1,
      pageSize: newPaginationModel.pageSize, // Update pageSize dynamically
    };

    setPayload((prev) => ({ ...prev, pagination }));
    setPaginationModel(newPaginationModel);
  };

  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 100,
  });

  useEffect(() => {
    fetchData();
  }, [payload]);

  const exportFile = async (fileType) => {
    await downloadDuesReport(fileType, payload);
  };

  const handleSortModelChange = (newModel) => {
    console.log(newModel, "newModel");
    if (newModel.length !== 0) {
      setSortModel(newModel);
      setPayload((prev) => ({ ...prev, sortFields: newModel }));
    }
  };

  return (
    <React.Fragment>
      <Helmet title="SaaS Dashboard" />
      <Grid justifyContent="space-between" container spacing={6}>
        <Grid item>
          <Typography variant="h4" gutterBottom>
            Due Statistics
          </Typography>
        </Grid>
      </Grid>
      <Divider my={4} />
      <Grid container spacing={6}>
        <Grid item xs={12} sm={12} md={6} lg={3} xl>
          <Stats
            title="Discount"
            amount={"₹" + dueReports.dueReportSum.discount}
            chip="Monthly"
            bgcolor="#f43f5e"
            icon={DiscountIcon}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3} xl>
          <Stats
            title="Service Tax"
            amount={"₹" + roundOff(dueReports.dueReportSum.serviceTax)}
            chip="Annual"
            bgcolor="#8b5cf6"
            icon={ReceiptLongIcon}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3} xl>
          <Stats
            title="Plan Amount"
            amount={"₹" + roundOff(dueReports.dueReportSum.planAmount)}
            chip="Weekly"
            bgcolor="#3b82f6"
            icon={CurrencyRupeeIcon}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3} xl>
          <Stats
            title="Total Payable Amount"
            amount={"₹" + roundOff(dueReports.dueReportSum.finalInvoiceAmount)}
            chip="Weekly"
            bgcolor="#10b981"
            icon={WalletIcon}
          />
        </Grid>
      </Grid>

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <CustomDataGrid
            trans={t}
            addPage={null}
            editPage={null}
            refreshPage={refreshPage}
            downloadFile={exportFile}
            openDownloadDialog={null}
            id="renewId"
            data={dueReports.data}
            rowCount={dueReports.paging.totalNumberOfRecords}
            paging={{
              page: dueReports.paging.pageNumber,
              pageSize: dueReports.paging.pageSize,
            }}
            onPaginationModelChange={onPageChange}
            isLoading={isLoading}
            sortModel={sortModel}
            handleSortModelChange={handleSortModelChange}
            setPayload={setPayload}
            payload={payload}
            setFilterResetFunc={setFilterResetFunc}
            filterFormData={filterFormData}
            setFilterFormData={setFilterFormData}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default DueReports;
